import React, { useEffect, useState } from 'react';
import { Button, Col, Row,Form as BootstrapForm } from 'react-bootstrap';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactSelect from 'react-select';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import moment from 'moment';
const customStyles = {
    input: (provided, state) => ({
        ...provided,
        // color: '#29cfb1',
        padding: '5px 0px'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: '#ced4da'
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        marginLeft: 5
    }),
    menuList: (provided, state) => ({
        ...provided,
        fontSize: 14,
        color: '#a4a4a4'
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const EditRewardPoints = () => {
    const [status, setStatus] = useState('active');
    const [data, setData] = useState();
    const {getToken}=useAuth();
    const validate = Yup.object({
        name: Yup.string().required('Required'),
        // email: Yup.string().required("Required"),
        noOfAllowRedeems: Yup.string().required('Required'),
        validity: Yup.string().required('Required'),
        requiredPoints: Yup.string().required('Required')
    });
    const navigate = useNavigate();

    const { state } = useLocation();
    const [routeOptions,setRouteOptions]=useState([]);
    const [selectedRoute,setSelectedRoute]=useState(null);
    useEffect(() => {
        if (state?.reward_id) {
            getRewardsDetail(state?.reward_id);
        }
    }, [state]);
   
    const getRewardsDetail = async (id = '') => {
        const token = getToken();
        const webApiCalls=new WebApiCalls();
         const routes=await webApiCalls.getAssociatedRoutes(token,state);
         const options=routes?.data.map((route) => ({ value: route?._id, label: route?.name }))
         setRouteOptions(options)
        if (token && id) {
            new WebApiCalls()
                .getRewardsDetials(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        const selectedRoute=options.filter(option=>option.value===res.data?.route)[0]||null
                        setSelectedRoute(selectedRoute);
                        setData(res.data);
                    }
                })
                .catch((err) => { });
        }
    };

    const handleSubmit = async (values, actions) => {
        // e.preventDefault()
        
        if(!selectedRoute)return toast.error('Please select a route');
        const id = state?.reward_id;
        const token = getToken();
        if (token && id) {
            const obj = {
                name: values.name,
                // email: values.email,
                noOfAllowRedeems: values.noOfAllowRedeems,
                requiredPoints: values.requiredPoints,
                validity: values.validity,
                status,
                route:selectedRoute.value
            };
            await new WebApiCalls()
                .updateReward(token, obj, id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Rewards is updated successfully.');
                        navigate(`${state?.redirect_url ? state?.redirect_url : '/reward-points'}`, {
                            state: { agency_id: state?.agency_id, agency_details: state?.agency_details, vendor_id: state?.vendor_id }
                        });
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {
                    console.log('Error here:    ', err);
                });
        }
    };
    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={8} lg={11} className="shadow-lg p-5 m-3">
                    <Formik
                        initialValues={{
                            name: data?.name || '',
                            // email: userEmail,
                            validity:moment(data?.validity).format("YYYY-MM-DD") || '',
                            noOfAllowRedeems: data?.noOfAllowRedeems || '',
                            requiredPoints: data?.requiredPoints || '',
                        }}
                        validationSchema={validate}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {(formik) => (
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            className="form-control common-input"
                                            label="Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter name"
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.noOfAllowRedeems}
                                            onChange={formik.handleChange}
                                            className="form-control common-input"
                                            label="Number of allowed Redeems"
                                            name="noOfAllowRedeems"
                                            type="number"
                                            placeholder="Enter allowed Redeems"
                                        />
                                    </Col>

                                    {/* <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                    <FormField value={formik.values.email} onChange={formik.handleChange} className="form-control common-input"
                      label="Email" name="email" type="email"
                      placeholder="Enter email" />
                  </Col> */}
                                </Row>

                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.requiredPoints}
                                            onChange={formik.handleChange}
                                            className="form-control common-input"
                                            label="Required Points"
                                            name="requiredPoints"
                                            type="number"
                                            placeholder="Enter Required Points"
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label htmlFor="transit_type">Status</label>
                                        <select value={status} onChange={(e) => setStatus(e.target.value)} name="transit_type" className="common-selector">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.validity}
                                            onChange={formik.handleChange}
                                            min={`${moment(new Date()).format('YYYY-MM-DD')}`}
                                            className="form-control common-input"
                                            label="Validity Date"
                                            name="validity"
                                            type="date"
                                            placeholder="Validity Date"
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className='mb-3'>
                                     <BootstrapForm.Group>
                                    <BootstrapForm.Label className='mb-1'>Route</BootstrapForm.Label>
                                    <ReactSelect options={routeOptions} value={selectedRoute}
                                        onChange={e => setSelectedRoute(e)} placeholder="Select route" />
                                    </BootstrapForm.Group>
                                    
                                </Col>
                                </Row>
                                

                                <div className="text-end">
                                    <Link
                                        state={{
                                            agency_id: state?.agency_id,
                                            agency_details: state?.agency_details,
                                            vendor_id: state?.vendor_id
                                        }}
                                        to={state?.redirect_url || '/reward-points'}
                                    >
                                        {/* // <Link to="/reward-points"> */}
                                        <Button className="theme-cancel-btn me-3">Cancel</Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
};
export default EditRewardPoints;
/*

    // const validate = Yup.object({
    //   district: Yup.string().required("Required"),
    //   keeper: Yup.string().required("Required"),
    //   email: Yup.string().email("Email is invalid").required("Required"),
    //   shield: Yup.string().required("Required"),
    // });

    // const keepersData = [
    //   {
    //     label: "Bro. Maceo raieiy",
    //     value: "maceo"
    //   },
    //   {
    //     label: "Qasim Khan",
    //     value: "qasim"
    //   },
    //   {
    //     label: "waqas Khan",
    //     value: "waqas"
    //   },
    //   {
    //     label: "Hamza",
    //     value: "hamza"
    //   },
    // ]

    // return (
    //   <>
    //     <Row className="d-flex justify-content-center">
    //       <Col xs={12} sm={12} md={8} lg={6} className="shadow-lg p-3 m-3">
    //         <Formik
    //           initialValues={{
    //             district: "1021",
    //             keeper: "Qasim Khan",
    //             email: "qasim@ropstam.com",
    //             shield: "sheild data",
    //           }}
    //           validationSchema={validate}
    //           onSubmit={(values) => {
    //             console.log("District Values", values);
    //           }}
    //         >
    //           {(formik) => (
    //             <Form>
    //               <FormField
    //                 label="District Number"
    //                 name="district"
    //                 type="text"
    //               />
    //               <FormSelect label="Keepers" name="keeper" data={keepersData} />
    //               <FormField label="Email Address" name="email" type="email" />
    //               <FormField
    //                 label="Theme Shield Upload"
    //                 name="shield"
    //                 type="text"
    //               />
    //               <div className="text-end">
    //                 <Link to="/districts"><Button type="submit" className="theme-cancel-btn me-3">
    //                   Cancel
    //                 </Button></Link>
    //                 <Button type="submit" className="theme-btn">
    //                   Update
    //                 </Button>
    //               </div>
    //             </Form>
    //           )}
    //         </Formik>
    //       </Col>
    //     </Row>
    //   </>
    // );
    */
